import { Base2Presenter } from "core/presenter";
import { CompanyRepository } from "core/repository";
import { pathOr } from "ramda";

export default class CompanyIntegrationsTrayPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      company: {
        integrations: {
          tray: {
            enabled: false,
            url: "",
            store_id: null
          }
        }
      }
    };
  }

  onStart() {
    this.checkIntegration();
  }

  checkIntegration() {
    if (this.props.company.integrations.tray) {
      this.enqueue({
        company: {
          integrations: {
            tray: this.props.company.integrations.tray
          }
        }
      });
    }
    const integrationEnabled = pathOr(
      false,
      ["integrations", "tray", "enabled"],
      this.props.company
    );
    this.enqueueTrayField("enabled", integrationEnabled);
  }

  async updateTrayFields() {
    return await CompanyRepository.update(
      this.props.company.uuid,
      this.viewModel.company
    );
  }

  onTrayAuthenticationFinished() {
    return new Promise(resolve => {
      this.enqueue({ loading: true });

      const finishSearch = timer => {
        clearInterval(timer);
        this.enqueue({ loading: false });
        resolve();
      };

      let counter = 0;
      const timer = setInterval(async () => {
        const result = await CompanyRepository.getOnline(
          this.props.company.uuid
        );
        if (result.success) {
          const integrationEnabled = pathOr(
            false,
            ["data", "integrations", "tray", "enabled"],
            result
          );
          if (integrationEnabled) {
            this.enqueueTrayField("enabled", integrationEnabled);
            finishSearch(timer);
          }
        }

        counter += 1;
        if (counter >= 10) {
          finishSearch(timer);
          this.sendNotification({
            type: "error",
            title: "Oops...",
            content:
              "Não foi possível realizar a autenticação com a Tray. Tente novamente em alguns momentos."
          });
        }
      }, 1000);
    });
  }

  enqueueTrayField(field, value) {
    this.enqueue(vm => ({
      company: {
        ...vm.company,
        integrations: {
          ...vm.company.integrations,
          tray: {
            ...vm.company.integrations.tray,
            [field]: value
          }
        }
      }
    }));
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/tray/presenter.js